<template>
  <div>
    <!-- Share modal -->
    <vs-prompt
      class="active-fields-modal"
      title="Compartilhar link"
      accept-text="OK"
      :active.sync="shareModal"
    >
      <social-sharing
        :url="urlToShare"
        title="SBT Caravanas"
        description="Cadastre-se na minha lista de contatos"
        quote="Para participar das gravações"
        hashtags="sbtcaravanas, sbt"
        inline-template
      >
        <div>
          <vs-row class="mt-3">
            <vs-col
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
              vs-w="12"
            >
              <network network="whatsapp">
                <feather-icon
                  icon="MessageCircleIcon"
                  svgClasses="h-4 w-4"
                />Whatsapp
              </network>
            </vs-col>
          </vs-row>
        </div>
      </social-sharing>
    </vs-prompt>

    <vs-row vs-justify="center" style="padding: 20px">
      <img
        src="@/assets/images/logo/sbt-caravanas-logo.png"
        alt="login"
        style="width: 80px; opacity: 0.5"
      />
    </vs-row>
    <h5 style="text-align: center">
      Nossas boas vindas ao <br />
      SBT Caravanas!
    </h5>
    <vs-row style="margin-top: 70px; max-width: 560px">
      <div class="dash-card-container">
        <a v-bind:href="'/gravacoes'">
          <div class="dash-card-box">
            <i class="fa fa-solid fa-video" />
            <span class="dash-card-label">Minhas Gravações</span>
          </div>
        </a>
      </div>
      <div class="dash-card-container">
        <a v-bind:href="'/contatos'">
          <div class="dash-card-box">
            <i class="fa fa-users" />
            <span class="dash-card-label">Meus contatos</span>
          </div>
        </a>
      </div>
    </vs-row>
    <vs-row> </vs-row>
    <vs-row class="new-contact-row">
      <p>Convidar novo contato</p>
      <button class="wpp-btn" @click="openShareModal">
        <i class="fa-brands fa-whatsapp" /> Compartilhar via whatsapp
      </button>
      <button class="link-btn" @click="copyToClipboard">
        <i class="fa-solid fa-copy" /> Copiar Link
      </button>
    </vs-row>
  </div>
</template>
<script>
import Vue from "vue";
import SocialSharing from "vue-social-sharing";
import { Plugins } from "@capacitor/core";
const { Share } = Plugins;

export default {
  components: {
    SocialSharing,
  },
  computed: {
    caravanistLogged() {
      return this.$store.state.AppActiveUser || {};
    },
    urlToShare() {
      let locationOrigin = location.origin.includes("localhost")
        ? "https://caravanas-pwa.sbtlab.io"
        : location.origin;

      return `${locationOrigin}/participante/${
        this.caravanistLogged.uuid
      }?name=${encodeURI(this.caravanistLogged.name)}`;
    },
  },
  data() {
    return {
      shareModal: false,
    };
  },
  methods: {
    openShareModal() {
      Share.share({
        title: "SBT Caravanas",
        text: "Cadastre-se na minha lista de contatos",
        url: this.urlToShare,
      })
        .then(() => console.log("Successful share"))
        .catch((error) => (this.shareModal = true));
    },
    copyToClipboard() {
      this.$copyText(this.urlToShare);
      this.$vs.notify({
        text: "Link copiado!",
        color: "primary",
        iconPack: "feather",
        icon: "favorite",
        time: 4000,
        position: "bottom-left",
      });
    },
  },
};
</script>

<style lang="scss">
.new-contact-row {
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: center;
  margin-top: 70px;
  padding: 0 10px;
}
.new-contact-row button {
  border-radius: 30px;
  padding: 12px;
  font-size: 14px;
  font-weight: bold;
  margin: 3px;
  border: 0;
}
.wpp-btn {
  background-color: #25d366;
  color: #fff;
}
.link-btn {
  color: #3d4451;
  background-color: #fff;
}

.dash-card-container {
  width: 50%;
  display: flex;
  justify-content: center;
}
.dash-card-container a {
  color: #3d4451 !important;
}
.dash-card-box {
  display: flex;
  flex-direction: column;
  max-width: 150px;
  text-align: center;
}
.dash-card-box i {
  font-size: 50px;
  margin-bottom: 6px;
}
</style>
